module.exports = __webpack_public_path__ + "img/ihumane-white-long.674e788b.svg";